import React from "react"
import { AuthenticationLayout } from "layoutsV2/client/AuthenticationLayout"
import { PasswordRecovery as PasswordRecoveryForm } from "ui/auth/PasswordRecovery"

export const PasswordRecovery = () => (
  <AuthenticationLayout type="signin">
    <PasswordRecoveryForm />
  </AuthenticationLayout>
)
